<template>
  <div class="document-notification">
    <div class="document-notification__wrapper">
      <div class="document-notification__user">
        <c-input-2
          v-model="notification.user"
          :class="{
            'is-invalid': validate && userError,
          }"
          floating-label="Ответственный"
          type="select"
          :items="usersDictionary"
          :searchable="true"
          :clearable="true"
        />

        <div v-if="validate && userError" class="feedback-error">
          {{ userError }}
        </div>
      </div>
      <c-input-2
        v-model="notification.filials"
        class="document-notification__filial"
        floating-label="Филиал"
        type="select"
        :multiple="true"
        :items="filialsDictionary"
        :searchable="true"
      />
      <div class="document-notification__checkboxes">
        <div class="document-notification__checkbox email">
          <c-switcher v-model="notification.email" type="checkbox" label="Email" />
        </div>
        <div class="document-notification__checkbox sms">
          <c-switcher v-model="notification.sms" type="checkbox" label="SMS" />
        </div>
      </div>
      <c-button-2
        v-b-tooltip
        class="document-notification__remove hidden-sm"
        size="iconic"
        title="Удалить"
        :icon="{ icon: 'trash', color: 'secondary' }"
        @click="$emit('remove')"
      />
      <c-button-2
        class="document-notification__remove hidden-md"
        size="small"
        label="Удалить"
        :icon="{
          icon: 'trash',
          color: 'secondary',
        }"
        @click="$emit('remove')"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Input2 from "@/components/controls2/Input";
import Button2 from "@/components/controls2/Button";
import Switcher from "@/components/controls/switcher";

export default {
  components: {
    "c-input-2": Input2,
    "c-button-2": Button2,
    "c-switcher": Switcher,
  },
  props: ["notification", "validate"],
  computed: {
    ...mapState("documentForm", ["usersDictionary", "filialsDictionary"]),
    userError() {
      if (!this.notification.filials.length) return null;
      return !this.notification.user || !this.notification.user.value ? "Обязательное поле" : "";
    },
  },
  created() {
    this.$store.dispatch("documentForm/loadUsers");
    this.$store.dispatch("documentForm/loadFilials");
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";

.document-notification {
  &__wrapper {
    display: flex;
    @media (max-width: 840px) and (min-width: 450px) {
      flex-wrap: wrap;
    }
    @include onlyExtraSmall {
      flex-direction: column;
    }
  }
  &__remove {
    flex-shrink: 0;
    margin-top: 20px;

    @media (max-width: 840px) {
      width: 401px;
      order: 1;
    }
    @include onlyExtraSmall {
      width: fit-content;
      margin-top: 0;
      margin-left: auto;
    }
  }
  &__user {
    width: 366px;
    flex-shrink: 0;
    margin-right: 30px;

    @media (max-width: 840px) {
      width: 216px;
      order: 0;
    }
  }
  &__filial {
    flex-grow: 1;
    margin-right: 30px;
    @include mobileAndTablet {
      width: 401px;
    }
  }

  @include onlyExtraSmall {
    &__user,
    &__filial {
      width: auto;
      margin-bottom: 25px;
      margin-right: 0;
    }
  }

  &__checkboxes {
    display: flex;
    @media (max-width: 840px) and (min-width: 450px) {
      order: 2;
    }
  }

  &__checkbox {
    flex-shrink: 0;
    margin-right: 34px;
    margin-top: 24px;

    @include onlyExtraSmall {
      margin-top: 0;
    }
  }
}
.hidden-sm {
  @include onlyExtraSmall {
    display: none !important;
  }
}
.hidden-md {
  @media (min-width: 450px) {
    display: none !important;
  }
}
</style>
